import {fetchAndParse, FetchResult} from './Common';
// interface DocumentExpressionsOptions {
// 	// expressionName: string;
// }

export class DocumentExpressionsClass {
	private static _instance: DocumentExpressionsClass;
	static instance() {
		return (this._instance = this._instance || new DocumentExpressionsClass());
	}
	private constructor() {}

	private _resultByUrl: Map<string, FetchResult> = new Map();
	url() {
		return `/editor/docs/description/expressions/traversers/functiongenerator.md`;
	}

	async fetch(): Promise<FetchResult | undefined> {
		const url = this.url();
		let result = this._resultByUrl.get(url);
		if (!result) {
			result = await fetchAndParse(url);
		}
		return result;
	}
}

export const DocumentExpressions = DocumentExpressionsClass.instance();
